// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"9079c851","186":"efb510d4","272":"03d8adaf","738":"16a48f15","841":"7bfadd14","851":"883e9f78","929":"cbd0187c","996":"16574103"}[chunkId] + ".chunk.js";
};